<template>
    <modal
        :title="translations.resubmitRequest || 'Resubmit request'"
        :cancel_btn_title="translations.no || 'No'"
        size="small"
        :loading="loading.resubmitPayout || loading.refreshBankRequirements"
    >
        <template #toggle>
            <btn type="light" size="small">{{ translations.resubmit || 'Resubmit' }}</btn>
        </template>
        <template #body>
            <div>
                <fieldset>
                    <div class="border rounded p-4 mb-4">
                        <div class="text-sm text-gray-500 normal-case font-normal text-left">
                            {{ translations.resubmitRequestReason || 'Resubmit request reason:' }}
                        </div>
                        <div class="bg-white text-left inline-flex w-full">
                            {{ resubmit_request_reason }}
                        </div>
                    </div>
                    <div class="-space-y-px bg-white rounded-md text-left">
                        <partner-payout-request-fields
                            ref="payoutFields"
                            :payout_invoice_path="payout_invoice_path"
                            :payout_invoice_src="payout_invoice_src"
                            :payout_id="payout_id"
                            :countries="countries"
                            :placeholders="placeholders"
                            :amount_unit="amount_unit"
                            :amount_with_units_formatted="amount_with_units_formatted"
                            :preferred_settings="preferred_settings"
                            :request-errors="requestErrors"
                            :available_methods="available_methods"
                            :translations="translations"
                            :refresh_bank_requirements_url="refresh_bank_requirements_url"
                            :payout_invoice_requirements='payout_invoice_requirements'
                            :bill_to_details="bill_to_details"
                            @loading-refresh-bank-requirements="handleRefreshBankRequirementsLoading"
                            @request-errors="requestErrors = $event"
                        />
                    </div>
                </fieldset>
            </div>
        </template>
        <template #footer>
            <btn
                :loading="loading.resubmitPayout"
                type="primary"
                @click="resubmitPayout"
            >
                {{ translations.resubmitRequest || 'Resubmit Request' }}
            </btn>
        </template>
    </modal>
</template>
<script>
export default {
    props: [
        'payout_id',
        'payout_invoice_path',
        'payout_invoice_src',
        'resubmit_url',
        'resubmit_request_reason',
        'countries',
        'placeholders',
        'request_url',
        'amount_unit',
        'amount_with_units_formatted',
        'preferred_settings',
        'styles',
        'available_methods',
        'translations',
        'refresh_bank_requirements_url',
        'payout_invoice_requirements',
        'bill_to_details'
    ],
    data() {
        return {
            loading: {
                resubmitPayout: false,
                refreshBankRequirements: false
            },
            requestErrors: null,
        }
    },
    methods: {
        resubmitPayout() {

            if (this.loading.resubmitPayout || this.loading.refreshBankRequirements || !this.$refs.payoutFields.validatePaymentInfo()) {
                return;
            }

            this.requestErrors = null;
            this.loading.resubmitPayout = true;

            axios.post(this.resubmit_url, {
                payout: this.payout_id,
                settings: {
                    requested_payment_settings: this.$refs.payoutFields.getPaymentSettings()
                },
                invoice_path: this.$refs.payoutFields.getInvoicePath()
            })
                .then(response => {
                    const status = parseInt(response.data.status || -1);
                    if (status === 1) {
                        window.location.reload();
                    } else if (status === 0 && response.data.bank_transfer_fields) {
                        this.$refs.payoutFields.setBankTransferFields(response.data.bank_transfer_fields)
                        this.requestErrors = {additional_fields: response.data.errors}
                    }
                })
                .catch(error => {
                    if (error.response && error.response.data && error.response?.data?.errors) {
                        this.requestErrors = Array.isArray(error.response.data.errors)
                            ? {additional_error: error.response.data.errors}
                            : error.response.data.errors;
                    }
                })
                .finally(() => this.loading.resubmitPayout = false);
        },
        handleRefreshBankRequirementsLoading(loading) {
            if (loading) {
                this.requestErrors = null;
            }
            this.loading.refreshBankRequirements = loading
        }
    }
}
</script>
